import React, { Component } from "react";
import PropTypes from "prop-types";
import { wrapComponent } from "../utils/container";
import {
    closeNotificationsPopover,
    fetchNotifications,
    openNotificationsPopover
} from "../actions/notifications.actions";
import NotificationsIcon from "material-ui-icons/Notifications";
import {
    IconButton,
    Button,
    Badge,
    Popover,
    List,
    ListItem,
    Typography,
    Divider,
    CircularProgress
} from "material-ui";
import { grey } from "material-ui/colors";
import Notification from "../components/Notification";
import { push } from "react-router-redux";

const styleSheet = theme => ({
    mainContainer: {
        maxWidth: 320,
        minWidth: 200,
        minHeight: 60
    },
    badge: {
        margin: `0 ${theme.spacing.unit * 2}px`
    },
    emptyNotificationMainContainer: {
        padding: theme.spacing.unit
    },
    list: {
        maxHeight: 500,
        overflow: "scroll"
    },
    emptyNotification: {
        width: 100,
        height: 100,
        margin: "0 auto",
        fill: grey[200]
    },
    emptyNotificationContainer: {
        display: "flex",
        alignItems: "center"
    },
    emptyMessage: {
        textAlign: "center"
    },
    button: {
        margin: `${theme.spacing.unit}px ${theme.spacing.unit}px ${theme.spacing
            .unit}px ${2 * theme.spacing.unit}px`
    },
    progress: {
        margin: `${4 * theme.spacing.unit}px auto`,
        display: "block"
    },
    seeAllButton: {
        marginLeft: 3.5 * theme.spacing.unit,
        "&:hover": {
            backgroundColor: "white"
        }
    }
});

function takeEdges(edges) {
    return edges.take(5);
}

class NotificationsMenu extends Component {
    state = {
        anchorEl: null
    };

    componentWillMount() {
        this.props.dispatch(fetchNotifications());
    }

    onButtonClick = () => {
        if (this.button) {
            this.props.dispatch(openNotificationsPopover());
            this.setState({ anchorEl: this.button });
        }
    };

    handleClose = () => {
        this.props.dispatch(closeNotificationsPopover());
    };

    renderNotifications() {
        const {
            t,
            classes,
            pagedRequest: { edges, request: { requesting, errors } }
        } = this.props;

        if (errors.count() > 0) {
            return;
        } else if (!requesting && edges.count() === 0) {
            return (
                <div className={classes.emptyNotificationMainContainer}>
                    <div className={classes.emptyNotificationContainer}>
                        <NotificationsIcon
                            className={classes.emptyNotification}
                        />
                    </div>
                    <Typography className={classes.emptyMessage} type="body1">
                        {t("notificationsMenu.You have no notifications")}
                    </Typography>
                </div>
            );
        } else if (requesting && edges.count() === 0) {
            return (
                <CircularProgress
                    className={classes.progress}
                    color="primary"
                    size={24}
                />
            );
        }
        return (
            <React.Fragment>
                <List className={classes.list}>
                    {takeEdges(
                        edges
                    ).map(({ node: notification, cursor }, i) => {
                        return (
                            <ListItem key={i + "_" + notification.id} dense>
                                <Notification notification={notification} />
                            </ListItem>
                        );
                    })}
                </List>
                <Divider />
                <Button
                    className={classes.seeAllButton}
                    dense={true}
                    onClick={this.onSeeAllNotifications}
                    color="primary">
                    {t("notificationsMenu.See all notifications")}
                </Button>
            </React.Fragment>
        );
    }

    onSeeAllNotifications = () => {
        this.props.dispatch(push("/notifications"));
    };

    renderNotificationIcon() {
        let { classes, pagedRequest: { edges } } = this.props;
        let hasUnviewed = !!takeEdges(edges).find(e => !e.node.viewedAtDate);

        if (hasUnviewed) {
            return (
                <Badge
                    className={classes.badge}
                    badgeContent="•"
                    color="accent">
                    <NotificationsIcon />
                </Badge>
            );
        }
        return <NotificationsIcon />;
    }

    render() {
        const { classes, open } = this.props;
        const { anchorEl } = this.state;
        return (
            <React.Fragment>
                <IconButton
                    onClick={this.onButtonClick}
                    buttonRef={button => {
                        this.button = button;
                    }}
                    key="notificationsButton"
                    className={classes.button}
                    aria-label="Notifications">
                    {this.renderNotificationIcon()}
                </IconButton>
                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClick={this.handleClose}
                    onClose={this.handleClose}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right"
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}>
                    <div className={classes.mainContainer}>
                        {this.renderNotifications()}
                    </div>
                </Popover>
            </React.Fragment>
        );
    }
}

NotificationsMenu.propTypes = {
    classes: PropTypes.object,
    dispatch: PropTypes.func,
    pagedRequest: PropTypes.object,
    open: PropTypes.bool,
    t: PropTypes.func.isRequired
};

function mapStateToProps({
    notifications: { open, notificationsPagedRequest: pagedRequest }
}) {
    return {
        open,
        pagedRequest
    };
}

export default wrapComponent(NotificationsMenu, styleSheet, mapStateToProps);



// WEBPACK FOOTER //
// ./src/containers/NotificationsMenu.jsx